import {HttpBackend, HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest} from '@angular/common/http';
import {firstValueFrom, map, Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {SessionService} from './session.service';


class HasuraHttpHandler implements HttpHandler {

  sess = inject(SessionService);

  constructor(private httpHandler: HttpHandler) {
  }

  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.sess.getAccessToken()}`);
    return this.httpHandler.handle(req.clone({url: `${req.url}`, headers}));
  }
}


export class HasuraHttp extends HttpClient {

  private protocol = window.location.protocol.replace('http', 'ws').replace('https', 'wss');
  private host = window.location.host;
  private wsUrl = `${this.protocol}//${this.host}/subscription`;
  sess = inject(SessionService);

  constructor(backend: HttpBackend, private root: string) {
    super(new HasuraHttpHandler(backend));
  }

  /*
    const result = await this.svr.runSql("select * from bpms.beds")
   */
  async runSql(sql: string) {
    return firstValueFrom(super.post(`/${this.root}/query`, {
      'type': 'run_sql',
      'args': {
        'sql': sql
      }
    }).pipe(map((res: any) => {
      if (!!res.errors) {
        const messages = res.errors.map((e: any) => e.message);
        throw Error(messages.join('; '));
      }
      return res;
    })));
  }


  /*
    const result = await this.svr.select("bpms_beds",
      ["bed", "accessible"],
      {hall: {_eq: "SR11"}},
      {hall: 'asc', bed: 'desc'},
      3
    );
   */
  async select(table: string, fields: string, whereClause: any = {}, orderBy: any = {}, limit: number = null) {
    const query = `query MyQuery($where: ${table}_bool_exp = {}, $order_by: [${table}_order_by!] = {}, $limit: Int = null) {
        ${table}(where: $where, order_by: $order_by, limit: $limit) {
          ${fields}
        }
      }`;
    const data = await this.execute(query, {
      'where': whereClause,
      'order_by': orderBy,
      'limit': limit,
    });
    return data[table];
  }

  async insert(table: string, objects: any[]) {
    const query = `mutation MyMutation($objects: [${table}_insert_input!] = {}) {
                                  insert_${table}(objects: $objects) {
                                    affected_rows
                                  }
                                }`;
    const data = await this.execute(query, {
      'objects': objects
    });
    return data[table];
  }

  async updateMany(table: string, updates: any[]) {
    const query = `mutation MyMutation($updates: [${table}_updates!]!){
                                  update_${table}_many(updates: $updates) {
                                    affected_rows
                                  }
                                }`;
    const data = await this.execute(query, {
      'updates': updates
    });
    return data[table];
  }

  async updateByPK(table: string, pk_columns: any, return_field: string[], object: any) {
    const query = `mutation MyMutation($_set: ${table}_set_input!, $pk_columns: ${table}_pk_columns_input!){
                                  update_${table}_by_pk(pk_columns: $pk_columns, _set: $_set) {
                                    ${return_field.join('\n')}
                                  }
                                }`;
    const data = await this.execute(query, {
      'pk_columns': pk_columns,
      '_set': object
    });
    return data[table];
  }

  async execute(query: string, variables: any): Promise<any> {
    const data = {
      'query': query,
      'variables': variables
    };
    return firstValueFrom(super.post(`/${this.root}/graphql`, data).pipe(map((res: any) => {
      if (!!res.errors) {
        const messages = res.errors.map((e: any) => e.message);
        throw Error(messages.join('; '));
      }
      return res?.data;
    })));
  }

  /*
    ks = toSignal(this.svr.subscription(`
    subscription MySubscription {
      bpms_halls {
        abbr
      }
    }`));
   */
  public subscription(query: string): Observable<any> {
    return new Observable<any>((subscriber) => {
      const ws = new WebSocket(this.wsUrl, ['graphql-ws']);
      ws.onerror = (err) => {
        subscriber.error(new Error('some error occurred'));
      };
      ws.onopen = () => {
        console.log('opening websocket here');
        const init_connection = {
          payload: {
            headers: {
              'content-type': 'application/json',
              'authorization': `Bearer ${sessionStorage.getItem(this.sess.getAccessToken())}`
            },
            lazy: true,
          },
          type: 'connection_init'
        };
        ws.send(JSON.stringify(init_connection));

        const data = {
          id: '1',
          payload: {
            extensions: {},
            operationName: 'MySubscription',
            query: query,
            variables: {}
          },
          type: 'start'
        };
        ws.send(JSON.stringify(data));

      };
      ws.onclose = () => {
        console.log('closing websocket here');
        subscriber.complete();
      };
      ws.onmessage = (e: any) => {
        try {
          const data = JSON.parse(e.data as string);
          if (data?.type === 'data') {
            subscriber.next(data.payload.data);
          }
        } catch (err) {
          console.log(err, e);
          subscriber.error(new Error('some error occurred: ' + err));
        }
      };
      // Teardown
      return () => {
        console.log('observable teardown');
        ws.close();
      };
    });
  }
}

@Injectable()
export class K3sHasura extends HasuraHttp {
  constructor(backend: HttpBackend) {
    super(new HasuraHttpHandler(backend), 'k3s-hasura');
  }
}

@Injectable()
export class SwarmHasura extends HasuraHttp {
  constructor(backend: HttpBackend) {
    super(new HasuraHttpHandler(backend), 'swarm-hasura');
  }
}
